/* app/js/src/components/common/colorPicker/color-picker.component.scss */
.cursor-pointer {
  cursor: pointer;
}
::ng-deep color-picker .color-picker {
  position: fixed;
  z-index: 3;
  top: 45% !important;
  left: 45% !important;
}
::ng-deep .color-picker .arrow-left {
  display: none;
}
.color-circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px #6782a4 solid;
  cursor: pointer;
  position: relative;
}
.color-circle.selected:before {
  content: " ";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border: 1px solid #6782a4;
  border-radius: 50%;
}
.label {
  margin-top: 14.5px;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
}
/*# sourceMappingURL=color-picker.component.css.map */
